import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white flex-col justify-start items-center gap-4 flex" }
const _hoisted_2 = { class: "self-stretch flex-col justify-start items-center gap-3 flex" }
const _hoisted_3 = { class: "self-stretch flex-col justify-start items-center gap-1 flex" }
const _hoisted_4 = { class: "text-center text-racq-med-grey text-xl2-bold racq-max-w-xl" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center h-[88px] w-[88px]"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  class: "flex items-center justify-center h-[88px] w-[88px]"
}
const _hoisted_8 = { class: "self-stretch flex-col justify-start items-center gap-4 flex" }
const _hoisted_9 = { class: "pb-2 flex-col justify-start items-center flex" }
const _hoisted_10 = { class: "justify-end items-end gap-1 inline-flex" }
const _hoisted_11 = { class: "text-center text-racq-dark-grey text-xl4-bold" }
const _hoisted_12 = { class: "justify-center items-center gap-2.5 flex" }
const _hoisted_13 = { class: "text-center text-racq-med-grey text-lg-bold" }
const _hoisted_14 = {
  key: 0,
  class: "justify-end items-end gap-1 inline-flex"
}
const _hoisted_15 = { class: "text-center text-racq-med-grey text-xl" }
const _hoisted_16 = { class: "pb-0.5 justify-start items-center gap-2.5 flex" }
const _hoisted_17 = { class: "text-racq-med-grey text-base" }
const _hoisted_18 = { class: "md:pb-4 flex-col justify-start items-center gap-6 flex" }

import { computed } from 'vue';
import { Text, Field, Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import { formatCurrency } from '@/utils/text-transforms';
import Tag from '@/components/Tag/Tag.vue';
import { TagSize, TagTypes } from '@/enums/tag-enums';
import { useI18n } from 'vue-i18n';
import { QuoteTypeCodes, IQuote, PaymentFrequency, getInsuranceTypeDisplayName } from '@/interfaces';
import { getOnlineDiscount } from '@/utils/iq-discounts';
import Skeleton from '@/components/Skeleton/Skeleton.vue';
import { IImage } from '@/interfaces/forms/image-interface';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteHeader',
  props: {
    fields: {},
    quote: {},
    paymentFrequencyBindings: {},
    loading: { type: Boolean },
    icon: {}
  },
  setup(__props: any) {

const translation = useI18n();
const dictionary: Record<string, string> = translation.getLocaleMessage('en') as any;
const skeletonBlocks = [
  {
    height: 26,
    width: 338,
    class: 'mb-3',
  },
  {
    height: 26,
    width: 176,
    class: 'mb-3',
  },
  {
    height: 88,
    width: 88,
    class: 'mb-3',
  },
  {
    height: 36,
    width: 244,
    class: 'mb-2',
  },
  {
    height: 36,
    width: 244,
    class: 'mb-6',
  },
  {
    height: 48,
    width: 204,
    class: 'mb-6',
  },
  {
    height: 26,
    width: 204,
    class: 'mb-5',
  },
];

const props = __props;

const headingTextReplaced = computed(() =>
  props.fields.headingText.value.replace(
    '{{insuranceType}}',
    getInsuranceTypeDisplayName(dictionary, QuoteTypeCodes[props.quote.quoteType!])
  )
);

const onlineDiscount = computed(() =>
  getOnlineDiscount(translation, props.quote, {
    showAsMonthly: props.quote.paymentFrequency == PaymentFrequency.Monthly,
  })
);

const isMonthly = computed(() => props.quote.paymentFrequency == PaymentFrequency.Monthly);
const monthlyPremium = computed(() => formatCurrency(props.quote.insuranceQuoteSummary?.monthlyDeposit ?? 0, 2));
const monthlyAnnualPremium = computed(() =>
  formatCurrency(props.quote.insuranceQuoteSummary?.monthlyAnnualPremium ?? 0, 2)
);
const yearlyAnnualPremium = computed(() =>
  formatCurrency(props.quote.insuranceQuoteSummary?.yearlyAnnualPremium ?? 0, 2)
);

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Text), {
              field: { value: headingTextReplaced.value }
            }, null, 8, ["field"])
          ])
        ]),
        (_ctx.icon?.fileName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.icon.fileName,
                alt: _ctx.icon.alt,
                class: _normalizeClass([
            'mb-2',
            _ctx.icon.rounded === undefined || _ctx.icon.rounded ? 'rounded-full' : '',
            _ctx.icon.width ? `w-[${_ctx.icon.width}px]` : 'w-[72px]',
            _ctx.icon.height ? `h-[${_ctx.icon.height}px]` : 'h-[72px]',
          ])
              }, null, 10, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.icon?.fileName && _ctx.fields.image?.value?.src)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_unref(Image), {
                media: _ctx.fields.image
              }, null, 8, ["media"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(isMonthly.value ? monthlyPremium.value : yearlyAnnualPremium.value), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(isMonthly.value ? _ctx.fields.monthly.value : _ctx.fields.annually.value), 1)
              ])
            ]),
            (isMonthly.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(monthlyAnnualPremium.value), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.fields.annually.value.replace('*', '')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_FormKit, _mergeProps({ type: "toggle" }, _ctx.paymentFrequencyBindings), null, 16),
            (onlineDiscount.value)
              ? (_openBlock(), _createBlock(Tag, {
                  key: 0,
                  tagText: onlineDiscount.value,
                  tagType: _unref(TagTypes).discount,
                  tagSize: _unref(TagSize).sm
                }, null, 8, ["tagText", "tagType", "tagSize"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.loading]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Skeleton, { blocks: skeletonBlocks })
    ], 512), [
      [_vShow, _ctx.loading]
    ])
  ], 64))
}
}

})